(function() {
    // 注册组件
    SR.modules.extend('svgPie', svgPie);

    function svgPie(options) {
        var ringWidth = options.ringWidth;
        var bgWidth = options.bgWidth || ringWidth;
        var linecap = options.linecap || 'butt';
        var color = options.color; // 自定义颜色
        var rotate = options.rotate || -90; // 是否旋转
        var direction = options.direction || 'clockwise'; // 旋转方向counterclockwise 逆时针
        var hasMask = !!options.mask;
        var hasGradient = !!options.gradient;
        var isAnimate = options.animite; // 是否需要动画
        var animiteDelay = options.animiteDelay || 0;
        var showText = options.showText !== undefined ? options.showText : true; // 是否显示中间的百分比
        var version;
        var perimeter;

        function createSvg(diameter, percent) {
            var centerPos = diameter / 2;
            var radius = diameter / 2 - ringWidth / 2;
            perimeter = Math.PI * radius * 2;

            var $svg = $('<svg width="' + diameter + '" height="' + diameter + '"></svg>').addClass('pie-chart');
            var circleBg = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            circleBg.setAttribute('cx', centerPos);
            circleBg.setAttribute('cy', centerPos);
            circleBg.setAttribute('r', radius);
            circleBg.setAttribute('stroke-width', bgWidth);
            circleBg.setAttribute('stroke', '#f0f0f0');
            circleBg.setAttribute('fill', 'none');
            circleBg.setAttribute('class', 'circle-bg');
            var circleRing = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            circleRing.setAttribute('cx', centerPos);
            circleRing.setAttribute('cy', centerPos);
            circleRing.setAttribute('r', radius);
            circleRing.setAttribute('stroke-width', ringWidth);
            circleRing.setAttribute('stroke-linecap', linecap);
            circleRing.setAttribute('class', 'circle-ring');
            var maskRing = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            if (hasMask) {
                maskRing.setAttribute('cx', centerPos);
                maskRing.setAttribute('cy', centerPos);
                maskRing.setAttribute('r', radius);
                maskRing.setAttribute('stroke-width', ringWidth + 1);
                maskRing.setAttribute('stroke-linecap', linecap);
                maskRing.setAttribute('stroke-dasharray', options.mask.dasharray);
                maskRing.setAttribute('stroke', options.mask.color);
                maskRing.setAttribute('fill', 'none');
                maskRing.setAttribute('class', 'circle-maskRing');
            }
            if (color) {
                circleRing.setAttribute('stroke', color);
            } else {
                circleRing.setAttribute('class', 'ring');
            }
            hasGradient && circleRing.setAttribute('stroke', 'url(#'+ options.gradient.id +')');
            circleRing.setAttribute('fill', 'none');
            if (isAnimate) {
                circleRing.setAttribute('stroke-dasharray', 0 + ' ' + perimeter);
            } else {
                circleRing.setAttribute('stroke-dasharray', perimeter * percent + ' ' + perimeter);
            }
            circleRing.setAttribute('transform', 'rotate(' + rotate + ', ' + centerPos + ', ' + centerPos + ')');

            var percentText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            if (showText) {
                var textNode = document.createTextNode((percent * 100).toFixed(2) + '%');
                percentText.setAttribute('x', '50%');
                percentText.setAttribute('y', '51%');
                percentText.setAttribute('text-anchor', 'middle');
                percentText.setAttribute('dominant-baseline', 'middle');
                percentText.setAttribute('class', 'percent-text');
                percentText.appendChild(textNode);
            }

            if (hasMask) {
                $svg.append(circleBg, circleRing, maskRing, percentText);
            } else {
                $svg.append(circleBg, circleRing, percentText);
            }
            if (hasGradient) {
                createGradient($svg[0], options.gradient.id, options.gradient.color);
            }
            
            return $svg;
        }

        this.draw = function() {
            var $el = $(options.element);
            if ($el.length === 0) {
                return;
            }
            var elW = $el.width();
            var percent = Number($el.attr('data-value')) || 0;
            var $svg = createSvg(elW, percent);
            var $circle = $svg.find('circle').eq(1);

            if (direction === 'counterclockwise') {
                $circle.css({
                    transform: 'rotateY(180deg) rotate(' + rotate + 'deg)',
                    'transform-origin': '50% 50%'
                });
            }

            $(options.element).append($svg);

            if (isAnimate) {
                setTimeout(function() {
                    $circle.attr('stroke-dasharray', perimeter * percent + ' ' + perimeter);
                }, animiteDelay);
            }
        };

        function createGradient(svg, id, stops) {
            var svgNS = svg.namespaceURI;
            var grad = document.createElementNS(svgNS, 'linearGradient');
            grad.setAttribute('id', id);

            for (var i = 0; i < stops.length; i++) {
                var attrs = stops[i];
                var stop = document.createElementNS(svgNS, 'stop');
                for (var attr in attrs) {
                    if (attrs.hasOwnProperty(attr)) stop.setAttribute(attr, attrs[attr]);
                }
                grad.appendChild(stop);
            }

            var defs = svg.querySelector('defs') || svg.insertBefore(document.createElementNS(svgNS, 'defs'), svg.firstChild);
            return defs.appendChild(grad);
        }
    }
})();
